import {
  CreditRequests_GetCreditRequestQuery,
  CreditRequests_GetCreditRequestQueryVariables,
} from '@/types';
import { gql } from '@apollo/client';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';

export const CREDIT_REQUEST_ITEM_FIELDS_FRAGMENT = gql`
  fragment CreditRequestItemFields on items {
    display_name
    name
    uuid
  }
`;

export const CREDIT_REQUEST_VARIANT_PACK_FIELDS_FRAGMENT = gql`
  fragment CreditRequestVariantPackFields on variants_packs {
    pack {
      unit
      uuid
    }
    item {
      ...CreditRequestItemFields
    }
    uuid
  }
  ${CREDIT_REQUEST_ITEM_FIELDS_FRAGMENT}
`;

export const CREDIT_REQUEST_BATCH_LINE_ITEM_FIELDS_FRAGMENT = gql`
  fragment CreditRequestBatchLineItemFields on credit_request_batch_line_items {
    credit_request_reason {
      display_name
      uuid
    }
    pack_price_in_micros
    photo_url_list
    quantity
    uom_override
    uuid
    variant_pack {
      ...CreditRequestVariantPackFields
    }
  }
  ${CREDIT_REQUEST_VARIANT_PACK_FIELDS_FRAGMENT}
`;

export const CREDIT_REQUEST_BATCH_FIELDS_FRAGMENT = gql`
  fragment CreditRequestBatchFields on credit_request_batches {
    uuid
    created_at
    created_by {
      name
      supplier_employee_overrides(
        where: {
          supplier: {
            supplier_chats: {
              credit_request_batches: { uuid: { _eq: $creditRequestBatchUUID } }
            }
          }
        }
      ) {
        name
        uuid
      }
      uuid
    }
    chat_uuid
    credit_request_batch_line_items {
      ...CreditRequestBatchLineItemFields
    }
    customer_facing_id
    order_invoice_uuid
  }
  ${CREDIT_REQUEST_BATCH_LINE_ITEM_FIELDS_FRAGMENT}
`;

export const GET_CREDIT_REQUEST_BATCH_QUERY = gql`
  query CreditRequests_GetCreditRequest($creditRequestBatchUUID: uuid!) {
    credit_request_batches_by_pk(uuid: $creditRequestBatchUUID) {
      ...CreditRequestBatchFields
    }
  }
  ${CREDIT_REQUEST_BATCH_FIELDS_FRAGMENT}
`;

export const useGetCreditRequestBatch = (creditRequestBatchUUID: string) => {
  return useWrappedQuery<
    CreditRequests_GetCreditRequestQuery,
    CreditRequests_GetCreditRequestQueryVariables
  >(GET_CREDIT_REQUEST_BATCH_QUERY, {
    fetchPolicy: 'cache-and-network',
    variables: {
      creditRequestBatchUUID,
    },
  });
};
